import { render, staticRenderFns } from "./RecentPages.vue?vue&type=template&id=b6077782&scoped=true&"
import script from "./RecentPages.vue?vue&type=script&lang=js&"
export * from "./RecentPages.vue?vue&type=script&lang=js&"
import style0 from "./RecentPages.vue?vue&type=style&index=0&id=b6077782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6077782",
  null
  
)

export default component.exports